import { FunctionComponent } from 'react';
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';

// Contexts
import { useViewDetected, ViewMedia } from '@Components/Utils/ViewDetected';

// Utilities
import classnames from 'classnames';

// Components
import Image from '@Components/Utils/Image';
import Layout from '@Components/Layout/Search';
import { PageView } from '@Components/Utils/Lazy/Script';
import SearchUI from '@Components/Layout/Search/Components/SearchUI';

// Types
import { GetServerSideProps, InferGetServerSidePropsType } from 'next';

// Styles
import styles from './Search.module.scss';

const TopSearch = dynamic(() => import('@Pages/tra-cuu/Components/TopSearch'));

export interface SearchProps {}

const Search: FunctionComponent<InferGetServerSidePropsType<typeof getServerSideProps> & SearchProps> = () => {
    const router = useRouter();
    const { deviceType } = useViewDetected();

    const className = classnames([
        styles.wrapper,
        {
            [styles.mobile]: ['mobile', 'tablet'].includes(deviceType),
        },
    ]);

    const handleSearch = (keyword: string) => router.push(`/tra-cuu/ket-qua?s=${keyword}`);

    return (
        <Layout onSearch={handleSearch} className={className}>
            <div className={styles.body}>
                <Image className={styles.image} width={560} height={250} src={'/assets/tra-cuu/img_search.png'} />
                <ViewMedia is={'desktop'}>
                    <SearchUI
                        onSearch={handleSearch}
                        className={styles.search}
                        titleClassName={styles.title}
                        title="Tra cứu nhanh thông tin sức khỏe"
                        placeholder="Tìm bệnh, Bác sĩ, hỏi đáp, phòng khám"
                    />
                </ViewMedia>
                <TopSearch />
            </div>

            <PageView />
        </Layout>
    );
};

export default Search;

export const getServerSideProps: GetServerSideProps = async () => {
    return {
        props: {},
    };
};
